import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, IndianRupee } from "lucide-react";
import { LOAN_PRODUCTS } from "@/lib/api";

export default function Services() {
  return (
    <div>
      <section className="bg-[#F4F4F5] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0052FF]">Loan Services</div>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl font-bold tracking-tight text-[#06152D]">
            All the loans you'll ever need.
          </h1>
          <p className="mt-4 text-[#52525B] max-w-2xl leading-relaxed">
            Nine specialised products, each backed by our partner banks and NBFCs.
            Pick a product to see indicative rates, eligibility notes and required documents.
          </p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {LOAN_PRODUCTS.map((p) => (
            <Link
              key={p.slug}
              to={`/services/${p.slug}`}
              className="lj-card-lift bg-white border border-[#E4E4E7] rounded-2xl p-6 block"
              data-testid={`services-card-${p.slug}`}
            >
              <div className="flex items-start justify-between">
                <div className="h-11 w-11 rounded-xl bg-[#EBF2FF] flex items-center justify-center text-[#0052FF]">
                  <IndianRupee size={22} />
                </div>
                <span className="text-[10px] font-semibold text-[#059669] text-right leading-tight max-w-[110px]">As per Bank/NBFC<br/>Eligibility</span>
              </div>
              <h3 className="mt-5 font-display font-bold text-lg text-[#06152D]">{p.label}</h3>
              <p className="mt-2 text-sm text-[#52525B]">{p.tagline}</p>
              <div className="mt-5 pt-4 border-t border-[#E4E4E7] flex items-center justify-between text-xs text-[#52525B]">
                <span>{p.tenure}</span>
                <span className="text-[#0052FF] font-semibold inline-flex items-center gap-1">Details <ArrowRight size={12} /></span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
